import React, { FC, useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Spinner, Center, Text, Box, Button } from '@chakra-ui/react';
import DataService from '../../services/DataService.ts';
import { Event } from '../../models/event.ts';
import PCTDSClock from '../../components/PCTDSClock/PCTDSClock';

const PCTDSClockPage: FC = () => {
  const { eventId } = useParams<{ eventId: string }>();
  const navigate = useNavigate();
  const [event, setEvent] = useState<Event | null>(null);
  const [loading, setLoading] = useState(!!eventId);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    if (!eventId) { setNotFound(true); setLoading(false); return; }
    DataService.getEvent(eventId)
      .then(e => {
        if (!e) { setNotFound(true); } else { setEvent(e); }
      })
      .catch(() => setNotFound(true))
      .finally(() => setLoading(false));
  }, [eventId]);

  if (loading) return <Center h="100vh"><Spinner size="xl" color="teal.400" /></Center>;

  if (notFound || !event) return (
    <Center h="100vh" flexDirection="column" gap={4} bg="#080A0E">
      <Text style={{ fontFamily: "'Rajdhani',sans-serif", fontSize: 48 }}>⏱️</Text>
      <Text style={{ fontFamily: "'Rajdhani',sans-serif", fontSize: 22, fontWeight: 700, color: '#F0F4FF' }}>
        No Active Tournament
      </Text>
      <Text style={{ fontFamily: "'Rajdhani',sans-serif", fontSize: 14, color: '#6B7590', textAlign: 'center', maxWidth: 320 }}>
        This clock link is not currently active. The Tournament Director will share a link when a game is running.
      </Text>
      <Button mt={4} colorScheme="teal" variant="outline" onClick={() => navigate('/dashboard')}>
        Go to Dashboard
      </Button>
    </Center>
  );

  return <PCTDSClock eventId={eventId} event={event} />;
};

export default PCTDSClockPage;
